import React from "react";
import "../App.css";

export default function Services() {
  return (
    <div className="page">
      <h2>Our Intelligence-as-a-Service Platform</h2>

      <p>
        At <strong>Conscious Neurons</strong>, we don’t just build software — we
        craft synthetic intelligence that understands, adapts, and evolves. Our
        mission is to bridge cognition and code, delivering solutions that
        behave less like tools and more like thoughtful collaborators.
      </p>

      <h3>🔍 Core Offerings</h3>
      <ul>
        <li>
          <strong>Neural Network Engineering</strong>
          <br />
          We design and deploy custom deep learning architectures — from
          convolutional networks for visual perception to transformers for
          advanced language modeling — built to mirror how humans learn,
          remember, and refine.
        </li>
        <li>
          <strong>AI System Integration</strong>
          <br />
          Integrate neural intelligence into your operations. Whether through
          smart APIs, edge devices, or enterprise platforms — we embed cognition
          where it matters most.
        </li>
        <li>
          <strong>Predictive & Prescriptive Analytics</strong>
          <br />
          Move beyond hindsight. Our models identify patterns, predict outcomes,
          and even suggest optimal actions — helping you make decisions that are
          not just data-driven, but future-aware.
        </li>
        <li>
          <strong>Cognitive Workflow Automation</strong>
          <br />
          Replace repetitive logic with intelligent agents. From CRM pipelines
          to financial dashboards, we create flows that think, learn, and adapt
          in real-time.
        </li>
        <li>
          <strong>AI Ethics & Conscious Design</strong>
          <br />
          We embed responsible AI practices into every layer — bias mitigation,
          interpretability, and explainability — ensuring your systems stay
          human-centered and future-aligned.
        </li>
      </ul>

      <h3>🌐 Industries We Empower</h3>
      <p>
        Our clients span fintech, healthtech, retail, logistics, education, and
        R&D. Conscious Neurons is your strategic AI partner — whether you're
        automating inventory with predictive learning or crafting personalized
        customer experiences using NLP.
      </p>

      <h3>🚀 The Conscious Difference</h3>
      <p>
        - We believe intelligence must serve humanity.
        <br />
        - We treat data with reverence, not just as numbers but as memory.
        <br />
        - We design for longevity, not just MVPs.
        <br />- And above all, we don’t just write code — we write cognition.
      </p>

      <p style={{ marginTop: "2rem", fontWeight: "bold" }}>
        Let’s co-create the future. Intelligence isn’t optional anymore — it’s
        infrastructure.
      </p>
    </div>
  );
}
